export default __webpack_public_path__ + "static/media/loading-spinner-ball-triangle.6973c10d.svg";